import { Auth, API } from "aws-amplify";
import { API_ENDPOINT_NAME } from "../consts/constants";
import { AxiosError } from "axios";

/**
 * ストレージサイズの取得
 *
 * @returns
 */
export const getStorageSizeOthers = async (idToken: string, email: string) => {
    try {
        const body = {
            request: {
                userAttributes: {
                    email: email,
                },
            },
        };

        const path = `/s3_get_storage_size_others`;
        const request = {
            body: body,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: idToken,
            },
        };

        const response = await API.post(API_ENDPOINT_NAME, path, request);
        return response;
    } catch (error) {
        const isAxiosError = (error: any): error is AxiosError => {
            return error?.isAxiosError === true;
        };

        if (isAxiosError(error)) {
            console.error("API Error:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
        } else if (error instanceof Error) {
            console.error("Error:", error.message);
        } else {
            console.error("Unexpected Error:", error);
        }

        throw error;
    }
};

/**
 * ストレージサイズの取得
 *
 * @returns
 */
export const getStorageSize = async () => {
    const userData = await Auth.currentAuthenticatedUser();
    const idToken = userData.signInUserSession.idToken.jwtToken;
    const body = {
        request: {
            userAttributes: {
                id_token: idToken,
            },
        },
    };
    const path = `/s3_get_storage_size`;
    const request = {
        body: body,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: idToken,
        },
    };
    const response = await API.post(API_ENDPOINT_NAME, path, request);
    return response;
};

/**
 * ファイルの共有
 * @param from_email 共有元のメールアドレス
 * @param to_email 共有先のメールアドレス
 * @param from_project 共有元プロジェクト
 * @param to_project 共有先プロジェクト
 * @param file_name 対象ファイル名
 */
export const shareFile = async (to_email: string, from_project: string, to_project: string, file_name: string) => {
    try {
        const userData = await Auth.currentAuthenticatedUser();
        const from_email = userData.attributes.email;
        const idToken = userData.signInUserSession.idToken.jwtToken;
        const body = {
            request: {
                userAttributes: {
                    id_token: idToken,
                },
                from_email: from_email,
                to_email: to_email,
                from_project: from_project,
                to_project: to_project,
                file_name: file_name,
            },
        };
        const path = `/s3_share_file`;
        const request = {
            body: body,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: idToken,
            },
        };
        console.log("API Request", API_ENDPOINT_NAME, path, userData);

        if (from_email === to_email) {
            throw new Error("You cannot share the project with yourself.");
        }

        const response = await API.post(API_ENDPOINT_NAME, path, request);
        return response;
    } catch (error) {
        const isAxiosError = (error: any): error is AxiosError => {
            return error?.isAxiosError === true;
        };

        if (isAxiosError(error)) {
            console.error("API Error:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
        } else if (error instanceof Error) {
            console.error("Error:", error.message);
        } else {
            console.error("Unexpected Error:", error);
        }

        throw error;
    }
};

/**
 * プロジェクトの共有
 * @param from_email ユーザのメールアドレス
 * @param to_email 共有先のメールアドレス
 * @param project_name フォルダ名（メールアドレスに続くプロジェクト名）
 */
export const shareProject = async (to_email: string, project_name: string) => {
    try {
        const userData = await Auth.currentAuthenticatedUser();
        const from_email = userData.attributes.email;
        const idToken = userData.signInUserSession.idToken.jwtToken;
        const body = {
            request: {
                userAttributes: {
                    id_token: idToken,
                },
                from_email: from_email,
                to_email: to_email,
                project_name: project_name,
            },
        };
        const path = `/s3_share_project`;
        const request = {
            body: body,
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
                Authorization: idToken,
            },
        };

        if (from_email === to_email) {
            throw new Error("You cannot share the project with yourself.");
        }

        const response = await API.post(API_ENDPOINT_NAME, path, request);
        return response;
    } catch (error) {
        const isAxiosError = (error: any): error is AxiosError => {
            return error?.isAxiosError === true;
        };

        if (isAxiosError(error)) {
            console.error("API Error:", {
                message: error.message,
                response: error.response?.data,
                status: error.response?.status,
            });
        } else if (error instanceof Error) {
            console.error("Error:", error.message);
        } else {
            console.error("Unexpected Error:", error);
        }

        throw error;
    }
};

/**
 * STSのクレデンシャル取得
 * @returns
 */
export const getSTScredentials = async () => {
    const userData = await Auth.currentAuthenticatedUser();
    const idToken = userData.signInUserSession.idToken.jwtToken;
    const body = {
        request: {
            userAttributes: {
                id_token: idToken,
            },
        },
    };
    const path = `/s3_sts_generation`;
    const request = {
        body: body,
        headers: {
            "Content-Type": "application/json; charset=UTF-8",
            Authorization: idToken,
        },
    };
    const response = await API.post(API_ENDPOINT_NAME, path, request);
    const credentials = {
        accessKeyId: response.AccessKeyId,
        secretAccessKey: response.SecretAccessKey,
        sessionToken: response.SessionToken,
        email: response.email,
        groupId: response.groupId,
    };
    return credentials;
};
